module.exports = __webpack_public_path__ + "static/media/34DSS11.b0429a6f.jpg";